import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { WarningModalData } from "src/app/shared/interfaces/warning-modal-data";

@Component({
  selector: "warning-modal",
  templateUrl: "./warning-modal.component.html",
  styleUrls: ["./warning-modal.component.scss"],
})
export class WarningModalComponent {
  constructor(
    public dialogRef: MatDialogRef<WarningModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: WarningModalData,
  ) {}

  dismiss(): void {
    this.dialogRef.close();
  }
}
